import { create } from 'zustand';
import { AccountApi, ApiUtils, CreditLimitEntity, RequestStrategyEnum } from '@shared/api';

interface ICreditLimitStore {
  loading: boolean;
  error: string | null;
  creditLimit: CreditLimitEntity | null;
  getCreditLimit: (accountId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCreditLimitStore = create<ICreditLimitStore>((set) => ({
  loading: false,
  error: null,
  creditLimit: null,

  getCreditLimit: ApiUtils.wrapperApi(async (accountId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.getCreditLimit(accountId, signal);
      set({ creditLimit: result ?? null, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ creditLimit: null, loading: false, error: null }),
}));
